export class UNITS {
  public static Kilogram = '85932f55-1c22-4324-9280-1568eab184b7';
  public static Second = 'e3624dac-40f7-4d0f-91cb-60714d538648';
  public static Minute = '55dfaf21-8ea2-4006-ab8d-996b59a85f2d';
  public static Hour = 'e9e1dded-7a19-41d9-8e91-b8d4ff2f7d24';
  public static CubicM = '16829DDC-88CD-405D-A3C1-827A8CF92209';
  public static Piece = 'e405dddf-2099-4a76-88ab-efa33c5b0db0';
}

